import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';

class GraphPie extends Component {
    constructor(props) {
        super(props);
        this.state = {            
            label: ['Sangat Baik', 'Baik', 'Cukup'],
            datasets: [],
            title: ""
        }
    }

    componentDidMount() {       
        if(this.props.data !== undefined) { 
            const object = this.props.data;
            if(this.props.tipe === 'SK') {
                this.setState({ label: ['Unggul', 'Baik', 'Cukup'] })
            }
            let arrData = [
                {
                    data: [object.pSangatBaik, object.pBaik, object.pCukup],
                    backgroundColor: [  "rgb(54, 162, 235)", "rgb(255, 99, 132)","rgb(255, 205, 86)"]
                }
            ];

            this.setState({
                title: object.aspek,
                datasets: arrData,
            })

        } 
    }

    render() {
        return(
            <Pie
                data={{
                    labels: this.state.label,
                    datasets: this.state.datasets
                }}
                options = {{  
                    legend: { position: 'bottom',
                    },
                    title: {
                        display: true,
                        text: this.state.title
                    },
                    responsive: false,
                    maintainAspectRatio: true,        
                }}
                width={300} height={240}
            />
        )
    }
}

export default GraphPie;